import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import gclpInit from 'initializations/pages/Gclp'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
      gclpInit.init("giftPage")
      const GiftPage = () => import(/* webpackChunkName: "gift-page" */ 'containers/Pages/Gift')
      new Vue({
        el: "#" + this.elemId,
        store,
        render: h => h(GiftPage)
      })
    }
}
